export const IQrWaiter = "IQrWaiter";
